import {GET_LOG} from "./logAction";

const initialState = {
    data : [],
    status : 0,
}

const logsReducer = (state = initialState, action) => {
    switch (action.type){
        case GET_LOG:
            return{
                ...state,
                data: action.payload.data,
                status: 200
            }

        default:
            return{
                data : [],
                status: 400
            }

    }
}

export default logsReducer